import { format } from "date-fns";
import {
  Bl,
  BlsExportResponse,
} from "../../../interfaces/bl-export/blexport.interface";
import { CustomIconButton } from "../../../components/common/icon-buttons/CustomIconButton";
import {
  IconCopy,
  IconEdit,
  IconFileDownload,
  IconFileUpload,
  IconHistory,
  IconTrash,
} from "@tabler/icons-react";

/**
 * Generates rows of Table BL Export
 *
 *
 * @param isAdminUser
 * @param tableOffset
 * @param donwloadFile
 * @param downloadCarta
 * @param handleOpenCloneModalRF
 * @param openModalDisable
 * @param setBlToEdit
 * @param setHistoryBlID
 * @param openModalDelete
 * @param handleUploadDocumentBLExport
 * @param data
 * @returns
 */

const adminOnly = "[admin_only]";

export const generateRowsBLExport = (
  isAdminUser: boolean,
  tableOffset: number,
  callback: () => void,
  donwloadFile: (bl: Bl, type: string, callback: () => void) => Promise<void>,
  downloadCarta: (bl: Bl, callback: () => void) => Promise<void>,
  handleOpenCloneModalRF: (blToClone: Bl) => void,
  openModalDisable: (idBl: number) => void,
  setBlToEdit: (bl: Bl) => void,
  setHistoryBlID: (value: number) => void,
  openModalDelete: (idBl: number) => void,
  openModalUploadDocument: (id: number) => void,
  data?: BlsExportResponse
) => {
  const rows =
    data?.bls?.map((bl, index) => ({
      number: index + 1 + tableOffset,
      id: String(bl.id_bl),
      booking: bl.cod_booking,
      dae: bl.dae,
      enter_hour:
        isAdminUser === true
          ? format(new Date(bl.fecha_ingreso), "dd/MM/yyyy - hh:mm aaa")
          : adminOnly,
      download_bl_copy: (
        <CustomIconButton
          toolTipText="Descargar BL COPY"
          icon={<IconFileDownload color={"orange"} />}
          disabled={
            bl.descargado_copy === true ||
            !bl.bl_file_copy ||
            bl.bl_file_copy === null
              ? true
              : false
          }
          onClick={() => donwloadFile(bl, "copy", callback)}
        />
      ),
      download_bl_original: (
        <CustomIconButton
          toolTipText="Descargar BL ORIGINAL"
          icon={<IconFileDownload color={"limegreen"} />}
          disabled={
            bl.descargado_original === true ||
            !bl.bl_file_original ||
            bl.bl_file_original === null
              ? true
              : false
          }
          onClick={() => donwloadFile(bl, "original", callback)}
        />
      ),
      download_carta: (
        <CustomIconButton
          disabled={!Boolean(bl.tiene_carta)}
          toolTipText="Descargar CARTA"
          icon={<IconFileDownload color="#FF8787" />}
          onClick={() => downloadCarta(bl, callback)}
        />
      ),
      clonar: (
        <CustomIconButton
          toolTipText="Clonar BL"
          icon={<IconCopy color="dodgerblue" />}
          onClick={async () => {
            handleOpenCloneModalRF(bl);
          }}
        />
      ),
      delete: (
        <CustomIconButton
          toolTipText="Desactivar BL"
          icon={<IconTrash color={"coral"} />}
          onClick={() => {
            openModalDisable(Number(bl.id_bl));
          }}
          disabled={bl.estado_procesamiento === "L" ? true : false}
        />
      ),
      creado_api:
        isAdminUser === true ? (bl.creado_api ? "SI" : "NO") : adminOnly,
      fecha_descarga_copy:
        isAdminUser === true
          ? bl.fecha_descarga_copy
            ? format(new Date(bl.fecha_descarga_copy), "dd/MM/yyyy - hh:mm aaa")
            : "-"
          : adminOnly,
      fecha_descarga_original:
        isAdminUser === true
          ? bl.fecha_descarga_original
            ? format(
                new Date(bl.fecha_descarga_original),
                "dd/MM/yyyy - hh:mm aaa"
              )
            : "-"
          : adminOnly,
      subir_document:
        isAdminUser === true ? (
          <CustomIconButton
            toolTipText="Subir documento"
            icon={<IconFileUpload color="royalblue" />}
            onClick={() => {
              openModalUploadDocument(Number(bl.id_bl));
            }}
          />
        ) : (
          adminOnly
        ),
      edit_bl:
        isAdminUser === true ? (
          <CustomIconButton
            toolTipText="Editar"
            icon={<IconEdit color="orange" />}
            onClick={() => {
              setBlToEdit(bl);
            }}
          />
        ) : (
          adminOnly
        ),
      history:
        isAdminUser === true ? (
          <CustomIconButton
            toolTipText="Historial"
            icon={<IconHistory color="dodgerblue" />}
            onClick={() => {
              setHistoryBlID(Number(bl.id_bl));
            }}
          />
        ) : (
          adminOnly
        ),
      delete_admin:
        isAdminUser === true ? (
          <CustomIconButton
            toolTipText="Eliminar BL"
            icon={<IconTrash color={"red"} />}
            onClick={() => {
              openModalDelete(Number(bl.id_bl));
            }}
          />
        ) : (
          adminOnly
        ),
    })) || [];

  return rows;
};
